import { type IntlShape } from 'react-intl'

import { type TENANT } from '../../tenant'

import {
  CONTACT_FORM_FULL_SUBJECT_KEYS,
  CONTACT_FORM_PHARMACEUTICAL_SUBJECT_KEYS,
  CONTACT_FORM_SUBJECT_CATALOG,
  type ContactFormSubjectKey,
  directContactFormSubjectCatalogGetValue,
} from './directContactFormSubjectCatalog'
import {
  directContactFormSubjectPolicyGetByTranslatedSubject,
  directContactFormSubjectPolicyIsAvailableForTenant,
} from './directContactFormSubjectPolicySelectors'

type ContactFormSubjectOption = { 'data-qa-id': string; value: string }

const getSubjectOptions = ({
  intl,
  subjectKeys,
  tenant,
}: {
  intl: IntlShape
  subjectKeys: readonly ContactFormSubjectKey[]
  tenant?: TENANT
}): ContactFormSubjectOption[] =>
  subjectKeys.flatMap((subjectKey) => {
    if (
      !directContactFormSubjectPolicyIsAvailableForTenant({
        subjectKey,
        tenant,
      })
    ) {
      return []
    }

    const { qaId } = CONTACT_FORM_SUBJECT_CATALOG[subjectKey]

    return qaId
      ? // eslint-disable-next-line unicorn/no-unnecessary-array-flat-map -- don't reference, refactor if touched
        [
          {
            'data-qa-id': qaId,
            value: directContactFormSubjectCatalogGetValue(intl, subjectKey),
          },
        ]
      : []
  })

export const directContactFormAccessorGetSubjects = ({
  intl,
  isSubjectPharmaRelated,
  option,
  tenant,
}: {
  intl: IntlShape
  isSubjectPharmaRelated?: boolean
  option?: string
  tenant?: TENANT
}): {
  options: ContactFormSubjectOption[]
  orderType: boolean
} => {
  const subjectKeys = isSubjectPharmaRelated
    ? CONTACT_FORM_PHARMACEUTICAL_SUBJECT_KEYS
    : CONTACT_FORM_FULL_SUBJECT_KEYS
  const options = getSubjectOptions({
    intl,
    subjectKeys,
    tenant,
  })
  const resolvedSubject = option
    ? directContactFormSubjectPolicyGetByTranslatedSubject({
        intl,
        subject: option,
      })
    : undefined

  return {
    options,
    orderType: resolvedSubject?.policy.isOrderRelated ?? false,
  }
}
